// PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  // Check if the user is logged in
  const isLoggedIn = sessionStorage.getItem("email");
  
  return isLoggedIn ? children : <Navigate to="/admin/login" replace />;
};

export default PrivateRoute;
